/**
 * Subscription Plans Service
 *
 * Single frontend source of truth for how we *consume* plan data.
 * Plan definitions themselves are served by the backend via `/api/subscription/plans`.
 */

import { api } from '../utils/api'

export type PublicPlanId = 'starter_free' | 'basic' | 'professional' | 'enterprise'

/** Sort order for public marketing and pricing surfaces (matches checkout tiers). */
export const PUBLIC_PLAN_ORDER: Record<string, number> = {
  starter_free: 0,
  basic: 1,
  professional: 2,
  enterprise: 3,
}

export interface SubscriptionPlan {
  id: PublicPlanId | string
  name: string
  description: string
  price: number | null
  yearlyPrice: number | null
  maxUsers: number
  maxProducts: number
  maxApiCalls: number
  maxPlatforms: number
  maxStorageGB: number
  qrCodeAccess: 'none' | 'basic' | 'branded' | string
  entitlements?: any
  features: string[]
  purchasable: boolean
}

export function normalizePlanId(id: string | null | undefined): PublicPlanId {
  const raw = (id || '').toLowerCase().trim()

  if (raw === 'trial' || raw === 'free_trial' || raw === 'free trial' || raw === 'free-trial'
      || raw === 'free' || raw === 'starter-free' || raw === 'starter_free' || raw === 'starter free') return 'starter_free'
  if (raw === 'starter' || raw === 'basic') return 'basic'
  if (raw === 'professional' || raw === 'pro') return 'professional'
  if (raw === 'enterprise' || raw === 'custom') return 'enterprise'
  return 'starter_free'
}

export async function listSubscriptionPlans(): Promise<SubscriptionPlan[]> {
  const response = await api.get('/subscription/plans')
  return response.data.data || []
}
